import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { mdiClose } from '@mdi/js';
import { Container } from './styles';
import IconButton from '../IconButton';
const GlobalAlert = ({
  children = null,
  type = null,
  onClose = null,
  visible = false,
  ...props
}) => /*#__PURE__*/React.createElement(Container, _extends({
  type: type,
  role: "alert",
  "data-visible": visible
}, props), children, onClose && /*#__PURE__*/React.createElement(IconButton, {
  icon: mdiClose,
  onClick: onClose,
  align: "middle",
  label: "Close",
  style: {
    position: 'absolute',
    right: '0.5rem',
    top: 'env(safe-area-inset-top, 0px)'
  }
}));
GlobalAlert.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['success', 'error']),
  onClose: PropTypes.func,
  visible: PropTypes.bool
};
export default GlobalAlert;
//# sourceMappingURL=index.js.map